module.exports = __webpack_public_path__ + "img/18.645b309d.png";